import Auth from '@aws-amplify/auth';
import {subscribe} from "../newsletter/subscriber";
import {Router} from "config/routes";
import Cookies from "js-cookie";

const EMAIL_COOKIE_NAME = 'e';

Auth.configure({
    region: process.env.COGNITO_REGION,
    userPoolId: process.env.COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.COGNITO_CLIENT_ID,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    cookieStorage: {
        domain: process.env.COGNITO_COOKIE_DOMAIN,
        expires: 365,
        path: '/',
        secure: (process.env.COGNITO_COOKIE_DOMAIN !== 'localhost')
    }
});

export default class {
    static login(username, password) {
        return new Promise((resolve, reject) => {
            return Auth.signIn(username, password)
                .then(() => {
                    return this.getUser()
                        .then((user) => {
                            resolve(user);
                        })
                })
                .catch((error) => {
                    reject(error);
                })
        });
    };

    static signup(username, email, password) {
        return new Promise((resolve, reject) => {
            if(!username.match(/^[0-9a-zA-Z_]{4,}$/)) {
                return reject({code:'InvalidUsernameException'});
            }

            Auth.signUp(username, password, email)
                .then(() => {
                    let user = null;

                    this.login(username, password)
                        .then((u) => {
                            user = u;
                        })
                        .catch()
                        .finally(() => {
                            subscribe(email, window.location.href, 'site_signup')
                                .then()
                                .catch()
                                .finally(() => {
                                    return resolve(user);
                                })
                        })
                })
                .catch((error) => {
                    return reject(error);
                })
        });
    };

    static forgotPassword(email) {
        return Auth.forgotPassword(email);
    };

    static forgotPasswordSubmit(email, code, password) {
        return Auth.forgotPasswordSubmit(email, code, password);
    };


    static logout() {
        Cookies.remove(EMAIL_COOKIE_NAME);
        return Auth.signOut();
    };

    static getUser() {
        return new Promise((resolve, reject) => {
            Auth.currentAuthenticatedUser()
                .then((user) => {
                    Auth.currentSession()
                        .then((session) => {
                            user.username = session.idToken.payload['cognito:username'];

                            resolve(user);
                        })
                        .catch((error) => {
                            reject(error);
                        })
                })
                .catch((error) => {
                    reject(error);
                })
        });
    };

    static setEmail(email) {
        Cookies.set(EMAIL_COOKIE_NAME, email, {expires: 365 * 3});
    };

    static getEmail() {
        return new Promise((resolve) => {
            this.getUser()
                .then((user) => {
                    resolve(user.attributes.email);
                })
                .catch(() => {
                    resolve(Cookies.get(EMAIL_COOKIE_NAME));
                });
        });
    };

    static changePassword(currentPassword, newPassword) {
        return new Promise((resolve, reject) => {
            return Auth.currentAuthenticatedUser()
                .then((user) => {
                    return Auth.changePassword(user, currentPassword, newPassword)
                        .then((data) => resolve(data))
                        .catch((error) => reject(error));

                })
                .catch((error) => {
                    reject({code: error});
                });
        })
    }
};
